// extracted by css-extract-rspack-plugin
export default {"cls1":"RecommendedPodcasts-cls1_N7h","cls2":"RecommendedPodcasts-cls2_2jI RecommendedPodcasts-cls1_N7h"};